export function hydrateChatAjaxConfigFromDom() {
    if (typeof window === 'undefined') {
        return {};
    }

    if (window.growtype_chat_ajax) {
        return window.growtype_chat_ajax;
    }

    const configNode = document.getElementById('growtype-chat-account-ajax-data');

    if (!configNode) {
        return {};
    }

    try {
        const parsedConfig = JSON.parse(configNode.textContent || '{}');
        window.growtype_chat_ajax = Object.assign({}, parsedConfig, window.growtype_chat_ajax || {});
    } catch (error) {
        console.warn('Failed to parse growtype chat account ajax config.', error);
    }

    return window.growtype_chat_ajax || {};
}

export function getChatAjaxConfig() {
    return hydrateChatAjaxConfigFromDom();
}
